<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Historial de cuentas por cobrar
    </h2>
    <MainListOfAccountsReceivablePayments />
  </div>
</template>

<script>
import MainListOfAccountsReceivablePayments from "@/components/Sales/AccountsReceivable/ListOfAccountsReceivablePayments/MainListOfAccountsReceivablePayments.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ListOfAccountsReceivablePayments",
  components: {
    MainListOfAccountsReceivablePayments,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
